import { flare } from "@flareapp/flare-client";

if (process.env.NODE_ENV === 'production' && window.location.hostname !== 'tba-qikcms.test') {
    flare.light();
    flare.addContext('version', window.__version);
}

require('./bootstrap');

require('@wotz/livewire-sortablejs');

// Apply class to all external links
const links = document.querySelectorAll("a[target^='_blank']");
links.forEach(child_element => {
    if (child_element) {
        child_element.classList.add('external-link');
        // child_element.setAttribute('rel', 'external');
    }
});

// Apply aria to all links
const aria_links = document.querySelectorAll("a");
aria_links.forEach(child_element => {
    if (child_element) {
        const label = child_element.innerText.replace('"', '').replace("'", '').replace('  ', ' ').replace('<br>', '').replace('<br/>', '').replace('\n', '').trim();
        child_element.setAttribute('aria-label', label);
        // if (!child_element.getAttribute('title')) {
        //     child_element.setAttribute('title', label);
        // }
    }
});

// Apply aria to all buttons
const aria_buttons = document.querySelectorAll("button");
aria_buttons.forEach(child_element => {
    if (child_element) {
        const label = child_element.innerText.replace('"', '').replace("'", '').replace('  ', ' ').replace('<br>', '').replace('<br/>', '').replace('\n', '').trim();
        child_element.setAttribute('aria-label', label);
        // if (!child_element.getAttribute('title')) {
        //     child_element.setAttribute('title', label);
        // }
        child_element.setAttribute('role', 'button');
    }
});

// Handle click away on header menu dropdowns
const subMenuDropContainers = document.querySelectorAll(".subMenuDropContainer");
subMenuDropContainers.forEach(subMenuDropContainer => {
    document.addEventListener('click', event => {
        const isClickInside = subMenuDropContainer.contains(event.target)
        if (!isClickInside) {
            const subMenuDropContainerChildren = subMenuDropContainer.querySelectorAll(".subMenuDrop");
            if (subMenuDropContainerChildren[0]) {
                subMenuDropContainerChildren[0].setAttribute('style', 'display: none;');
            }
        }
    })
});

window.onerror = function (message, source, lineno, colno, error) {
    // if (window.location.hostname === 'tba-qikcms.test'){
    //     return false;
    // }
    if (message?.includes('contentWindow')) {
        document.getElementById('preview_frame')?.contentWindow?.location.reload();
        return true;
    }
    if (message?.includes('Snapshot missing')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (message?.includes('Could not find Livewire component in DOM tree')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (message?.includes('Component not found')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (message?.includes('Alpine Expression Error')) {
        if (Livewire !== undefined) {
            Livewire.dispatch('refreshPageComps');
            Livewire.dispatch('reloadCompListData');
        }
        return true;
    }
    if (message?.includes("null is not an object (evaluating 'Object.prototype.hasOwnProperty.call")) {
        return true;
    }
    if (message?.includes("null is not an object (evaluating 'document.elementFromPoint")) {
        return true;
    }
    if (message?.includes("null is not an object (evaluating 'e.contentWindow.postMessage")) {
        return true;
    }
    if (message?.includes("Unable to decode audio data")) {
        return true;
    }
    if (message?.includes("Jsloader error (code #1): Timeout reached for loading script https://apis.google.com/js/client.js")) {
        return true;
    }
    if (message?.includes("Jsloader error (code #1):")) {
        return true;
    }
    if (message?.includes("apis.google.com/js/client.js")) {
        return true;
    }
    if (message?.includes("TypeError: Cannot convert undefined or null to object")) {
        return true;
    }
    if (message?.includes("Failed to fetch dynamically imported module: https://www.googletagmanager.com")) {
        return true;
    }
    if (message?.includes("googletagmanager.com")) {
        return true;
    }
    if (message?.includes("[USO]")) {
        return true;
    }
    if (source?.includes("gtag")) {
        return true;
    }
    if (source?.includes("youtube.com")) {
        return true;
    }
    if (source?.includes("chrome-extension") || source?.includes("tracking_script.js") || source?.includes("injected.js")) {
        return true;
    }
    if (!source?.includes(window.location.hostname)) {
        return true;
    }
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent && /mobi|ipad|iphone|android|touch|mini/.test(userAgent)) {
        return true;
    }
}
const originalWarn = console.warn;
console.warn = function(message, ...optionalParams) {
    if (window.location.hostname === 'tba-qikcms.test') {
        console.log('Warning:', message, optionalParams);
    }
    window._warnings = window._warnings || [];
    window._warnings.push({ message, ...optionalParams });
    if (window.flare) {
        window.flare.reportMessage(message, ...optionalParams);
    }
    originalWarn(message, optionalParams);
}
if (window.location.hostname !== 'tba-qikcms.test'){
    flare.beforeSubmit = function(report) {
        let passedChecks = true;
        if (report?.message?.includes('Alpine Expression Error')) {
            passedChecks = false;
        }
        if (report?.message?.includes('contentWindow')) {
            passedChecks = false;
        }
        if (report?.message?.includes('Snapshot missing')) {
            passedChecks = false;
        }
        if (report?.message?.includes('Could not find Livewire component in DOM tree')) {
            passedChecks = false;
        }
        if (report?.message?.includes('Component not found')) {
            passedChecks = false;
        }
        if (report?.message?.includes("null is not an object (evaluating 'Object.prototype.hasOwnProperty.call')")) {
            passedChecks = false;
        }
        if (report?.message?.includes("null is not an object (evaluating 'document.elementFromPoint")) {
            passedChecks = false;
        }
        if (report?.message?.includes("null is not an object (evaluating 'e.contentWindow.postMessage")) {
            passedChecks = false;
        }
        if (report?.message?.includes("Unable to decode audio data")) {
            passedChecks = false;
        }
        if (report?.message?.includes("Jsloader error (code #1): Timeout reached for loading script https://apis.google.com/js/client.js")) {
            passedChecks = false;
        }
        if (report?.message?.includes("Jsloader error (code #1):")) {
            passedChecks = false;
        }
        if (report?.message?.includes("apis.google.com/js/client.js")) {
            passedChecks = false;
        }
        if (report?.message?.includes("Failed to fetch dynamically imported module: https://www.googletagmanager.com")) {
            passedChecks = false;
        }
        if (report?.message?.includes("googletagmanager.com")) {
            passedChecks = false;
        }
        if (report?.message?.includes("[USO]")) {
            passedChecks = false;
        }
        if (report?.source?.includes("gtag")) {
            passedChecks = false;
        }
        if (report?.source?.includes("realworklabs")) {
            passedChecks = false;
        }
        if (report?.stacktrace[0]?.file?.includes("realworklabs.com")) {
            passedChecks = false;
        }
        if (report?.stacktrace[0]?.file?.includes("youtube.com")) {
            passedChecks = false;
        }
        if (report?.stacktrace[0]?.file?.includes("injected.js")) {
            passedChecks = false;
        }
        if (report?.stacktrace[0]?.file?.includes("chrome-extension") || report?.stacktrace[0]?.file?.includes("tracking_script.js")) {
            passedChecks = false;
        }
        if (!report?.stacktrace[0]?.file?.includes(window.location.hostname)) {
            passedChecks = false;
        }
        let userAgent = navigator.userAgent.toLowerCase();
        if (!userAgent) {
            userAgent = report?.context.userAgent.toLowerCase();
        }
        if (userAgent && /mobi|ipad|iphone|android|touch|mini/.test(userAgent)) {
            passedChecks = false;
        }
        if (!passedChecks) {
            return false;
        }
        return report;
    }
}